export const readObject = (key = "") => {
  try {
    const value = localStorage.getItem(key);
    if (value === null) {
      return undefined;
    }
    return JSON.parse(value);
  } catch (error) {
    console.log("Error on localstorage readObject", error);
    return undefined;
  }
};

export const readPrimitive = (key = "") => {
  try {
    const value = localStorage.getItem(key);
    if (value === null) {
      return undefined;
    }
    return value;
  } catch (error) {
    console.log("Error on localstorage readPrimitive", error);
    return undefined;
  }
};

export const writeObject = (key = null, obj = null) => {
  if (!key && !obj) return;
  try {
    localStorage.setItem(key, JSON.stringify(obj));
  } catch (error) {
    console.log("Error on localstorage writeObject", error);
  }
};

export const writePrimitive = (key = null, value = null) => {
  if (!key && !value) return;
  try {
    localStorage.setItem(key, value);
  } catch (error) {
    console.log("Error on localstorage writePrimitive", error);
  }
};
